<div class="flex h-full min-h-0 flex-1 flex-col">
  <div class="flex flex-none flex-row items-start justify-between w-full">
    <h2 data-test-id="create-user-title">{{ titleText }}</h2>
    @if (isSubmitting) {
      <mat-spinner [diameter]="24" />
    }
  </div>

  <div class="flex-1 min-h-0">
    <mat-stepper #stepper class="create-user-stepper h-full min-h-0 w-full" [linear]="true">
      <mat-step label="Select template">
        <app-select-user-template class="h-full min-h-0" (selectTemplateSignal)="selectTemplate($event)" />
      </mat-step>

      <mat-step label="User details">
        <div class="flex h-full min-h-0 flex-col pt-4">
          <app-user-form
            class="flex-1 min-h-0"
            [clients]="clients"
            [template]="selectedTemplate"
            (isSubmittingSignal)="handleIsSubmitting($event)"
            (createUserSignal)="createUser($event)"
          />
        </div>
      </mat-step>
    </mat-stepper>
  </div>
</div>
